/**
 * Password visibility toggle — event delegation (aman untuk Vite ES module).
 */
(function bindPasswordToggleDelegation() {
  if (document.documentElement.dataset.passwordToggleBound === '1') {
    return;
  }
  document.documentElement.dataset.passwordToggleBound = '1';

  function resolveInput(button) {
    const targetId = button.getAttribute('data-password-toggle');
    if (targetId) {
      return document.getElementById(targetId);
    }

    return button.closest('.password-input-field')?.querySelector('[data-password-input]') ?? null;
  }

  function setVisible(button, input, visible) {
    const value = input.value;

    input.setAttribute('type', visible ? 'text' : 'password');

    if (visible && value) {
      input.value = '';
      input.value = value;
    }

    button.classList.toggle('is-revealed', visible);
    button.setAttribute('aria-pressed', visible ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      visible ? 'Sembunyikan password' : 'Tampilkan password'
    );
    button.setAttribute(
      'title',
      visible ? 'Sembunyikan password' : 'Tampilkan password'
    );

    button.closest('.password-input-wrap')?.classList.toggle(
      'password-input-wrap--visible',
      visible
    );

    input.focus({ preventScroll: true });

    if (value) {
      try {
        input.setSelectionRange(value.length, value.length);
      } catch (_) {
        // ignore
      }
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-password-toggle]');
    if (!button || button.disabled) {
      return;
    }

    const input = resolveInput(button);
    if (!input || input.disabled || input.readOnly) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    const willShow = input.getAttribute('type') === 'password';
    setVisible(button, input, willShow);
  });
})();

export {};
